import * as CL from '@design-system/component-library';
import { dsClass } from '../../common/constants/dsClasses';
import { t } from '../../common/i18n';
import type { DiscontinuedProduct } from '../../generated/api/discontinuedProduct';

interface DiscontinuedCatalogsDisclaimerProps {
  discontinuedProducts: DiscontinuedProduct[];
}
export const DiscontinuedCatalogsDisclaimer = ({ discontinuedProducts }: DiscontinuedCatalogsDisclaimerProps) =>
  discontinuedProducts.length > 0 ? (
    <div className={dsClass.PADDING_BOTTOM_4}>
      <CL.Disclaimer
        disclaimerType="warning"
        icon={<CL.Icon icon="notification" type="light" />}
        title={t.WK3U(
          'The device list contains products that have been removed from selection and are no longer available.'
        )}
        text={t.NWDY('If necessary, add new products to the list.')}
        showCloseButton={true}
      />
    </div>
  ) : null;
